export default __webpack_public_path__ + "static/Inter-Medium-d5afc4bd2dfa4a0c724aa9641936cd78.woff2";